import { FONT_TITLE } from '../../constants/AppConstants';
import ScreenFill from './ScreenFill';

// empty group that will automatically center itself
export default class ScreenContainer extends Phaser.Group {
  constructor(game, { background = false, title = false, modal = false } = {}) {
    super(game);

    this.game.scale.onSizeChange.add(this.positionContainer, this);

    if (background) {
      this.setBackground(background);
    }

    if (modal) {
      // create a screen fill for the background
      this.blackout = new ScreenFill(this.game, 0x8a308a, 0.65, true);
      this.blackout.inputEnabled = true;
      this.addChildAt(this.blackout, 0);
    }
    if (title) {
      this.setTitle(title);
    }

    this.positionContainer();
  }

  setTitle(value) {
    if (!this.title) {
      const fontStyle = {
        font: '62px ' + this.game.titleFontStyle,
        fill: '#FFFFFF',
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 960,
      };
      this.title = this.game.make.text(this.game.defaultWidth * 0.5, 50, '', fontStyle);
      this.title.setShadow(0, 4, 'rgba(0,0,0,0.15)', 0);
      this.title.anchor.set(0.5, 0);
      this.add(this.title);
    }
    this.title.text = value;
  }

  setBackground(background) {
    if (!this.bg) {
      this.bg = this.game.make.image(0, 0);
      this.bg.anchor.set(0.5);
      this.bg.x = this.game.defaultWidth * 0.5;
      this.bg.y = this.game.defaultHeight * 0.5;
      this.addChildAt(this.bg, 0);
    }
    this.bg.loadTexture(background);
  }

  fadeInNewBg(background) {}

  positionContainer() {
    this.x = (this.game.width - this.game.defaultWidth) / 2;
    this.y = (this.game.height - this.game.defaultHeight) / 2;
  }

  update() {
    super.update();
  }

  destroy() {
    if (this.blackout) {
      this.blackout.destroy();
      this.blackout = null;
    }
    if (this.bg) {
      this.bg.destroy();
      this.bg = null;
    }
    if (this.title) {
      this.title.destroy();
      this.title = null;
    }

    this.game.scale.onSizeChange.remove(this.positionContainer, this);
    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/display/ui/ScreenContainer.js